import { useEffect, useState } from 'react';
import './AlertPopup.css';

// Simple beep sound
const playAlertSound = () => {
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    const oscillator = audioContext.createOscillator();
    const gainNode = audioContext.createGain();

    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);

    oscillator.type = 'sine';
    oscillator.frequency.setValueAtTime(880, audioContext.currentTime); // A5
    oscillator.frequency.exponentialRampToValueAtTime(440, audioContext.currentTime + 0.5); // Drop to A4

    gainNode.gain.setValueAtTime(0.5, audioContext.currentTime);
    gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.5);

    oscillator.start();
    oscillator.stop(audioContext.currentTime + 0.5);
};

function AlertPopup({ notification, onClose }) {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (notification) {
            setVisible(true);
            playAlertSound();

            const timer = setTimeout(() => {
                setVisible(false);
                setTimeout(onClose, 300); // Wait for animation
            }, 5000);

            return () => clearTimeout(timer);
        }
    }, [notification, onClose]);

    if (!notification) return null;

    return (
        <div className={`alert-popup ${visible ? 'visible' : ''}`}>
            <div className="alert-popup-content">
                <div className="alert-popup-icon">🔔</div>
                <div className="alert-popup-details">
                    <h3>Price Alert Triggered!</h3>
                    <p>{notification.message}</p>
                    <div className="alert-popup-meta">
                        <span className="alert-popup-crypto">{notification.crypto}</span>
                        <span className="alert-popup-price">${notification.price?.toLocaleString()}</span>
                    </div>
                </div>
                <button className="alert-popup-close" onClick={() => setVisible(false)}>×</button>
            </div>
        </div>
    );
}

export default AlertPopup;
